import {
  dealCarDatas
} from '@/cllib/sys_lib'

import {
  carSignGetData,
  carSignIn
} from '@/api/api'

const state = {
  carSignList: [],
  carSignTotal: 0
}

const getters = {
  carSignList: state => state.carSignList
}

const actions = {
  loadCarSignList ({ dispatch }, parm) {
    return carSignGetData(parm).then((data) => {
      dispatch('setCarSignList', dealCarDatas(data))
    })
  },
  carSignIn ({ dispatch }, parm) {
    return carSignIn(parm)
  },
  setCarSignList ({ commit }, data) {
    commit('setCarSignList', data)
  }
}

const mutations = {
  setCarSignList (state, data) {
    state.carSignList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/car_sign.js